/**
 * Saves an already fetched blob under the given name. The name is ours to
 * build: Content-Disposition is not exposed across origins.
 */
const downloadBlob = (blob: Blob, fileName: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = fileName;
  link.click();

  URL.revokeObjectURL(url);
};

export { downloadBlob };
